<template>
    <div style="background:white; height:100%">     
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">   
            <div style="width:70px;line-height:30px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px; ">{{ $LANG('0138', '新增') }} </span></el-link>
            </div>
            <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')"  filterable  size="small" style="width:150px; ">
                <span v-for="item in tabCol" :key='item.key' >
                    <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <el-select v-model="selparam2"  :placeholder="$LANG('1675', '请选择列名')"  size="small" style="width:150px;  ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"  ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
            <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
 
        </div> 
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :footer-data="footerData"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="tabHeight"
                :scroll-width="0"
                :column-width-resize-option="columnWidthResizeOption"
                :cellSelectionOption="{enable: false}"
                v-loading="v_loading"
                ref="tabref">
        </ve-table>
 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:50vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="small" :disabled="saveFlag" type="month"  v-if="item.FLDNO==='YRMTH'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM" style="width:100%" ></el-date-picker>   
                                <el-input-number size="small" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="small" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="small" filterable :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input size="small" :disabled="saveFlag" v-else-if="item.EDCSS==='button'" v-model="mainRow[item.FLDNO]"  @focus="inputBtn('','',item.FLDNO)" style="width:100%;border:1px solid #778899"></el-input>
                                
                                <el-input size="small" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>

             
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="saveFlag" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
 
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
    </div>
</template>
<script>
import pubWin from '../datamgt/pubwin.vue' 
import repWin from '../datamgt/repWin.vue'   
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate ,format_number} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"sale_plan",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '412732',
            fieldIdseq: '412732',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            v_radio:'PRD',
            nextWin:false,
            allSel:'N',
            supval:'',
            dateval:'',
            rmkval:'',
            clntCol:[],
            reqData:[],
            repWin:false,
            repUrl:'',
            supArr:[],
            drawer:false,
 
      
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false,
            prodWin:false,
            prompt:'',
            selparam3:'YRMTH',
            oper3:'like',
            txtparam3:'',
            selparam4:'',
            oper4:'like',
            txtparam4:'',
            tmplRmk:'',
            stfgCss:'',
            chkIndex:'',
            stfgColor:'',
            mainRow:{},
            input_hold:this.$LANG('1718', '请输入查询的值'),
            cashArr:[], // 
            listIndex:'-1',
            active:'', //二级菜单选中标志
            stfg_:'ALL',
            mattyArr:[],
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            dtlValidate:{},
            formArr:[],
            tabData:[], //表数据
            initCol:[],
            vueCol:[],
            footerData:[],
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
                footerCellClass: () => 'table-foot-cell-class',
            },
       
            tabCol:[], //表列
  
  
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'YRMTH',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            v_row:{},
            v_loading:false,
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
 
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            notDtl:[],
            current:1,
            taxArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            deptArr:[],      
            v_stknm :'',
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            v_key:'',
            v_tabRow:{},
            v_tabIndex:'',
 
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            nextData:[],
            v_idseq:'',
            selAll:'N',
            finWin:false,
            payData:[],
            v_commit:true,
            maxHeight:'',
        }
    },
    mounted () { 
        this.showkey()
        this.maxHeight = document.documentElement.clientHeight - 560
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412732','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412732','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        getBaseData('xuper_auth/getTableRecMany','corpid',this.v_corpid,'','','hr_frame','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.mattyArr =res.result
        })
 
        //表单所以下拦框动态赋值
        this.comSelect()
        //供应商
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
 
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14410','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.cashArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','412732','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412732','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
 
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 400) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 120) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        repWin,
        pubWin,
        VeColumnConfigDialog,
        // JSX query headers are resolved at runtime.
        // eslint-disable-next-line vue/no-unused-components
        VeTableQueryHeader,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getPcList('')
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        //状态变更
        stfgRec(row,val,index){
            let v_comm=''
            if (val==='Y'){
                v_comm=this.$LANG('0134', '审核')
            }else if (val==='N'){
                v_comm=this.$LANG('0137', '弃审')
            }else if (val==='X'){
                v_comm=this.$LANG('0131', '删除')
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this ,cond_='',v_user='',v_dttm=''
                if (val==='Y'){
                    v_user =this.v_usernm
                    v_dttm =getDate('full')
                    cond_=' set stfg=\'Y\' ,chkdttm=\''+v_dttm+'\' ,chkuser=\''+v_user+'\',upddttm=\''+getDate('full')+'\''
                }else{
                    v_user =''
                    v_dttm =''
                    cond_=' set stfg=\''+val+'\' , chkdttm=null  , chkuser=null,upddttm=\''+getDate('full')+'\''
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'SALE_PLAN',p_cond: cond_},
                }).then(res=>{      
                    if(res.code =='200')  {
                        if (val=='X'){
                            this.tabData.splice(index,1)
                        }else{        
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_user,CHKDTTM:v_dttm})
                        }
                    }else{
                        this.prompt=res.result
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})           
        },
        //对指定列进行合计 
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return  Number(Number(prev) +Number(curr) ).toFixed(1) 
                        }else{
                            return  prev 
                        }
                    },'')
                }
            })
            return  sums 
        },
        updateFooterData(){
            const qty = this.tabData.reduce((sum, row) => sum + (Number(row.QTY) || 0), 0)
            const amt = this.tabData.reduce((sum, row) => sum + (Number(row.AMT) || 0), 0)
            this.footerData = [{
                rowKey: 0,
                rownum: this.$LANG('0280', '合计'),
                QTY: qty ? qty.toLocaleString() : '',
                AMT: amt ? amt.toLocaleString() : '',
            }]
        },
 
        btnSure(obj){
            if (this.v_key =='CLNTNO'){
                Object.assign(this.mainRow,{CLNTNO:obj['IDNO'],CLNTNM:obj['CLNTNM'],CLTYPENM:obj['CLTYPENM'] })
            }    
            this.btnWin =false
        },
        inputBtn( row, index, key){
            this.v_key =key    
            if (key =='CLNTNO'){ //客户
                this.v_table ='v_bs_clnt'
                this.tableCol =this.clntCol
                this.v_key2 =''
                this.v_value2 =''
                this.btnWin =true
            }    
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'412732',p_cond:' and lstseq in (1)',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                        this.prompt=item.FLDNM+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit ) {    
                this.v_commit=false
                let obj_ ={}, v_title=''
                // 明细记录非空校验
 
                    Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid }) 
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'SALE_PLAN',frmid:'412732'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
       
                            vm.drawer =false   
                            vm.getPcList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
              
            }
        },
 
        //订单明细
        getPcList(cond){
            const requestId =++this.queryRequestId
            this.v_loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey)
                ? this.headerSortKey
                : (isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'YRMTH')
            const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:`${cond} order by ${orderField} ${orderDirection}`,p_table:'V_SALE_PLAN'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.tabData =res.result || []
                    this.updateFooterData()
   
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.v_loading =false
            }) 
        },
 
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
 
 
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{ 
               this.saveFlag=false
            }
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true   
            this.v_commit=true
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
        //查询
        qryTabData(){
            const firstCondition =buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const secondCondition =buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, { numberOperatorDefault: '>=' })
            const cond_ =firstCondition+secondCondition+headerCondition
            this.getPcList( cond_)
        },
        rowShow(){
            this.v_row ={}
            this.qryTabData()
        },
        sortHeaderColumn(column){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            else {
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            this.qryTabData()
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={DTTM:getDate('day'), STAFF:this.v_usernm, STFG:'N'}
            this.saveFlag=false
            this.v_commit=true
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412732','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.tabCol.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            sortable: item.SORTABLE,
                            notnull: item.NOTNULL,
                        })
                        if (item.THIDE !== 'N') return
                        const column = item
                        vm.vueCol.push({
                            field: column.key,
                            key: column.key,
                            title: vm.$translate.getColTitle(column, vm.$store.state.lang),
                            type: column.EDCSS === 'checkbox' ? 'check' : column.EDCSS,
                            align: column.align,
                            width: Number(column.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column: veColumn}) => <VeTableQueryHeader
                                title={veColumn.title}
                                edcss={column.EDCSS}
                                value={this.v_row[column.key]}
                                operator={this.v_row[`#OPER${column.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={column.key !== 'RN' && column.SORTABLE === 'N' && column.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === column.key ? this.headerSortOrder : ''}
                                options={['select', 'checkbox'].includes(String(column.EDCSS || '').toLowerCase()) ? (this.comboArr[column.key] || []) : []}
                                on-input={(value) => this.$set(this.v_row, column.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${column.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(veColumn)}
                                on-query={this.qryTabData}
                            />,
                            renderBodyCell: ({row}) => {
                                if (column.key === 'IDNO2') {
                                    return (
                                        <el-link underline={false} on-click={() => vm.repBtn(row)}>
                                            <div style="color:#409eff;border-bottom:1px solid red;font-size:11px">{row[column.key]}</div>
                                        </el-link>
                                    )
                                }
                                if (column.EDCSS === 'checkbox') {
                                    return <el-checkbox true-label="Y" disabled false-label="N" v-model={row[column.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                return <div>{row[column.key]}</div>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div class="sale-plan-sequence-header"><div class="sale-plan-sequence-header__title">{column.title}</div><el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 155,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.disabled} on-click={() => vm.editRec(row, 'Y')} underline={false}>
                                    <span style="font-size:11px;margin-right:5px;">{vm.$LANG('0139', '查看')}</span>
                                </el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}>
                                        <span style="font-size:11px;margin-right:5px;">{vm.$LANG('1639', '编辑')}</span>
                                    </el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link on-click={() => vm.stfgRec(row, 'X', rowIndex)} underline={false}>
                                        <span style="font-size:11px;">{vm.$LANG('0131', '删除')}</span>
                                    </el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
 
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','94','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.clntCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height:18px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
